<script>
	import { productStore } from '../../stores/products.store';
	import ProductCard from './ProductCard.svelte';
</script>

<section class="section new-arrival">
	<div class="title">
		<h1>Featured</h1>
		<p>All the latest picked from our store</p>
	</div>

	<div class="product-center">
		{#each $productStore.slice(0, 4) || [] as item}
			<ProductCard {item} />
		{/each}
	</div>
</section>
